// requestIdleCallback的兼容性处理
export const requestIdleCallback = (callback: () => void, timeout: Millisecond = 0) => {
    if (window.requestIdleCallback) {
        return window.requestIdleCallback(callback, { timeout });
    }
    return setTimeout(callback, timeout);
};
